import { useEffect } from 'react';
import { Info } from 'lucide-react';

const Toast = ({ message, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(onClose, 3500);
        return () => clearTimeout(timer);
    }, [onClose]);

    return (
        <div className="fixed bottom-6 right-6 z-50 bg-slate-900 text-white px-5 py-4 rounded-2xl border border-slate-800 shadow-2xl flex items-center gap-3 max-w-sm animate-slideIn">
            <span className="p-1.5 bg-blue-500/25 text-blue-400 rounded-lg flex items-center justify-center">
                <Info className="w-4 h-4" />
            </span>
            <div>
                <h5 className="text-xs font-bold uppercase tracking-wider text-slate-400">System Notification</h5>
                <p className="text-xs text-slate-200 mt-0.5">{message}</p>
            </div>
        </div>
    );
};

export default Toast;
